/** @format */

const CarrelloTranslations = {
    en: {
      'CarrelloTranslations.header.title': 'Booked Services ',
      'CarrelloTranslations.header.titleBold': 'cart',
      'CarrelloTranslations.header.breadcrumb': "Cart",
    },
    it: {
      'CarrelloTranslations.header.title': 'Carrello ',
      'CarrelloTranslations.header.titleBold': 'servizi prenotati',
      'CarrelloTranslations.header.breadcrumb': "Carrello",    
    },
  };
  
  export default CarrelloTranslations;
  